const initPeopleDirectory = (peopleDirectory) => {
    const loadMore = peopleDirectory.querySelector('.js-load-more');
    const table = peopleDirectory.querySelector('.js-sort-table');
    const rows = table.querySelectorAll('.js-sort-row');
    const sortBtns = peopleDirectory.querySelectorAll('.js-sort-btn');

    let nameOrder = 'asc';
    let roleOrder = 'asc';
    let studioOrder = 'asc';

    let loadMoreVisible = true;

    if (loadMore) {
        loadMore.addEventListener('click', () => {
            if (loadMoreVisible) {
                loadMoreVisible = false;
                loadMore.remove();
            }

            rows.forEach((card) => {
                card.classList.remove('hidden');
            });
        });
    }

    const sortTable = (data, button) => {
        let sortedRows;

        if (data === 'name') {
            if (nameOrder === 'desc') {
                sortedRows = [...rows].sort((a, b) => (a.dataset.name > b.dataset.name ? 1 : -1));
                button.classList.add('asc');
                nameOrder = 'asc';
            } else {
                sortedRows = [...rows].sort((a, b) => (a.dataset.name < b.dataset.name ? 1 : -1));
                button.classList.remove('asc');
                nameOrder = 'desc';
            }
        }

        if (data === 'role') {
            if (roleOrder === 'desc') {
                sortedRows = [...rows].sort((a, b) => (a.dataset.role > b.dataset.role ? 1 : -1));
                button.classList.add('asc');
                roleOrder = 'asc';
            } else {
                sortedRows = [...rows].sort((a, b) => (a.dataset.role < b.dataset.role ? 1 : -1));
                button.classList.remove('asc');
                roleOrder = 'desc';
            }
        }

        if (data === 'studio') {
            if (studioOrder === 'desc') {
                sortedRows = [...rows].sort((a, b) => (a.dataset.studio > b.dataset.studio ? 1 : -1));
                button.classList.add('asc');
                studioOrder = 'asc';
            } else {
                sortedRows = [...rows].sort((a, b) => (a.dataset.studio < b.dataset.studio ? 1 : -1));
                button.classList.remove('asc');
                studioOrder = 'desc';
            }
        }

        sortedRows.forEach((row) => {
            table.appendChild(row);
        });
    };

    sortBtns.forEach((button) => {
        button.addEventListener('click', () => {
            if (loadMoreVisible && loadMore) {
                loadMoreVisible = false;
                loadMore.remove();
            }

            rows.forEach((card) => {
                card.classList.remove('hidden');
            });

            const data = button.dataset.sort;

            sortTable(data, button);
        });
    });
};

export { initPeopleDirectory as default };
